export class ChangeableProperty {
  public newPropertyValue: any = undefined;
  public editMode: boolean = false;
  public changeValue: boolean = false;
}
